import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { useStagedFilesUpload } from '@/matter-asset-common/files/hooks/useStagedFilesUpload'
import { TIMELINE_FOLDER_NAME } from '../constants'
import { TimelineAssetActions } from '../store/slice'

/** Timeline keeps staging in Redux so uploads can finish after leaving its Add Files page. */
export function useTimelineAssetFilesUpload({ matterId }: { matterId: string | null }) {
  const dispatch = useAppDispatch()
  const staging = useAppSelector((state) => state.timelineAssetState.addFilesStaging)
  return useStagedFilesUpload({
    enabled: true,
    matterId,
    folderName: TIMELINE_FOLDER_NAME,
    sourceId: `timeline-asset-files-upload-${matterId ?? 'none'}`,
    stagedUserFileIds: staging.stagedUserFileIds,
    pendingUploadClientIds: staging.pendingUploadClientIds,
    onFileRegistered: (clientTmpId) => dispatch(TimelineAssetActions.addPendingUserFileUpload(clientTmpId)),
  })
}
